import React, { Component, Fragment } from 'react';
import ReactInterval from 'react-interval';


export default class RandomProjectImage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            images : this.props.images,
            image_index: 0,
            shape_index: 1
        }

        this.handleInterval = this.handleInterval.bind(this);
    }

    handleInterval(){  
        let shape = Math.floor((Math.random() * 5) + 1);

        let image_index = this.state.image_index;
        image_index = image_index == this.state.images.length-1? 0: image_index + 1;
        this.setState({
            image_index : image_index,
            shape_index: shape
        });

    }

    render() {
        return (
            <Fragment>
                <ReactInterval timeout={3000} enabled={true} callback={() => this.handleInterval()} />
                <div width="400px" className={`shape-${this.state.shape_index} width-400 bg-blue-secondary`}>
                    <div>
                        <img src={this.state.images[this.state.image_index]} width="400px" height="400px" className={`shape-${this.state.shape_index} cover`}/>
                    </div>
                </div>
            </Fragment>
        );
    }
}